document.querySelectorAll('.hero__video-cover').forEach((cover) => {
  const iframe = cover.querySelector('iframe');
  if (!iframe) return;

  const reveal = () => cover.classList.add('is-ready');

  const revealAfterLoad = () => {
    window.setTimeout(reveal, 400);
  };

  const fallbackTimer = window.setTimeout(reveal, 2500);

  iframe.addEventListener(
    'load',
    () => {
      window.clearTimeout(fallbackTimer);
      revealAfterLoad();
    },
    { once: true }
  );
});
